import store from '@/store'

export default async (_, from, next) => {
  await store
    .dispatch('getUser')
    .then(() => next())
    .catch(() => {
      if (from.path !== '/auth')
        next({
          name: 'Auth'
        })
    })
}
